import Transfer from './Transfer';
export default Transfer;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-transfer/src/index.js